import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="focus"
export default class extends Controller {
  static targets = ["focusable"]
  static values = {
    delay: { type: Number, default: 300 }
  }

  focus() {
    setTimeout(() => {
      this.focusableTarget.focus()
    }, this.delayValue)
  }
}
